var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
define(["require", "exports", "hypo_elements/Typescripts/UrlParameters/UrlParameters"], function (require, exports, UrlParameters) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    UrlParameters = __importStar(UrlParameters);
    (function () {
        var USE_URL_PARAM = "leadId";
        var ELEMENT_SELECTOR = ".leadid-reader a";
        var leadId = UrlParameters.getParameterByName(USE_URL_PARAM);
        if (leadId) {
            var leadIdLinks = document.querySelectorAll(ELEMENT_SELECTOR);
            leadIdLinks.forEach(function (element) {
                appendLeadIdOnElement(element, leadId);
            });
        }
    })();
    function appendLeadIdOnElement(element, leadId) {
        if (!window["platformPath"]) {
            return;
        }
        var platformPath = window["platformPath"].replace("c-agentservice", "c-customerservice");
        var platformVersion = "v1/";
        var action = "registration?leadId=";
        var source = "source=danke-seite";
        var attribute = platformPath + platformVersion + action + leadId;
        if (leadId) {
            attribute += "&" + source;
        }
        element.setAttribute("href", attribute);
    }
});
